<template>
  <div class="food-products">
    <div v-for="item of dataTable" :key="item.id" class="food-products__item food-item">

      <div class="food-item__header header">
        <el-image class="header__icon"
                  :fit="'cover'"
                  :src="item.icon"/>
        <div class="header__title">{{ item.title }}</div>
      </div>
      <div class="food-item__textarea textarea">
        <div class="textarea__positive">
          <el-input
              v-model="item.recommended"
              class="number-widget"
              type="textarea"
              placeholder="Рекомендуемые продукты..."
              autosize
              rows="2"
              resize="none"
          />
        </div>
        <div class="textarea__negative">
          <el-input
              v-model="item.not_recommended"
              class="number-widget"
              type="textarea"
              placeholder="Нежелательные продукты..."
              rows="2"
              resize="none"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ProductRecommendation",
  components: {},
  data() {
    return {
      loading: false,
      editable: false,
      editIndex: 0,
    }
  },
  props: {
    dataTable: {}
  },
  computed: {},

  methods: {
    setEditable(id) {
      this.editable = true
      this.editIndex = id

      this.$forceUpdate()
    },
    save() {
      this.editable = false
      this.$emit('update')
    },

  }
}

</script>
<style lang="scss" scoped>

.food-item {
  margin-top: 16px;

  &__header {
    background: #F6F8F9;
    border: 1px solid #F6F8F9;
    border-radius: 4px 4px 0 0;

    padding: 7px 12px;
  }

  &__textarea {
    border: 1px solid #e4e7ed;
    border-radius: 0 0 4px 4px;

  }
}

.textarea {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  height: 100% !important;

  &__positive {
    width: 50%;
    border-top: 3px solid #43D3B3;
    border-right: 1px solid #e4e7ed;
  }

  &__negative {
    width: 50%;
    border-top: 3px solid #E06161;
  }
}

.header {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 7px 12px;

  &__icon {
    width: 26px;
    background: #FFC65B;
    border-radius: 6px;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    color: #111;
  }
}

.number-widget {
  width: 100%;
  height: 100% !important;

  /deep/ textarea {
    height: inherit;
    //min-height: 51px;
    border: 0 !important;

  }
}

</style>